import styled from 'styled-components/macro'

import { Layout } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { Card } from './OfferCard.styles'

export { Card as CardMobile }

export const CardColumnsContainerMobile = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
  padding: 10px 10px 6px 10px;
`

export const LeftColumnMobile = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  justify-content: space-between;
`

export const RightColumnMobile = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: end;
  align-self: stretch;
  justify-content: space-between;
`

export const TopSectionMobile = styled.section`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-self: flex-end;
`

export const BottomSectionMobile = styled(Layout.Group)`
  margin: ${getToken('space-m')};
  flex-wrap: nowrap;
`

export const BottomSectionGroupMobile = styled(Layout.Group)`
  height: 100%;
  flex: 1;
  flex-wrap: nowrap;
`

export const RouteMobile = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;

  > :not(:last-child) {
    margin-right: none;
  }
`

export const OfferActionsMobile = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  & > button {
    margin: 0 ${getToken('space-xs')};
  }
`

export const FooterDividerMobile = styled.div`
  height: 1px;

  background-color: ${getToken('color-neutral-lighter')};
`

export const BottomSectionFooterMobile = styled.div`
  align-items: center;
  width: 100%;
  padding: ${getToken('space-s')} min(7.86vw, ${getToken('space-xl')});
`

export const PriceInfo = styled(Layout.Group)`
  padding: ${getToken('space-s')} 0px;
`

export const LoadRequirementsContainerMobile = styled.div`
  padding: 12px 10px;
`

export const FeatureTags = styled.div`
  color: ${getToken('color-accent')};
  font-weight: ${getToken('font-weight-bold')};
  font-size: ${getToken('font-size-5')};
`
